import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import common from './modules/common';
import booking from './modules/booking';
import messenger from './modules/messenger';
import loggedAccount from './modules/loggedAccount';
import monitoringTime from './modules/monitoringTime';
import prescriptionDme from './modules/prescriptionDme';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    monitoringTime: state.monitoringTime,
  }),
});

export const vuexStoreObject = {
  modules: {
    common,
    booking,
    messenger,
    loggedAccount,
    monitoringTime,
    prescriptionDme,
  },
  plugins: [vuexLocal.plugin],
};

const store = new Vuex.Store(vuexStoreObject);

export default store;
